import {
  IChangePasswordParams,
  IExperienceLoginParams,
  IForgotPasswordLiveParams,
  IForgotPasswordLiveResponse,
  ILoginMobileParams,
  ILoginResponse,
  ILoginWebParams,
  IRequestCrmOtpParams,
  IRequestCrmOtpResponse,
  ISignUpCrmParams
} from '@aqx-core/common/api/auth';
import { request } from '@aqx-core/common/request';

export default {
  loginWebCRM: (params: ILoginWebParams) => request.post<ILoginResponse>('/api/auth/v1/company/login', params),
  loginMobileCRM: (params: ILoginMobileParams) =>
    request.post<ILoginResponse>('/api/auth/v1/company/mobile/login', params),
  logout: () => request.post('/api/auth/v1/logout'),
  changePassword: (params: IChangePasswordParams) => request.patch<boolean>('/api/auth/v1/password', params),
  extendSession: () => request.patch<boolean>('/api/auth/v1/session'),
  signUpCrm: (params: ISignUpCrmParams) => request.post<string>('/api/auth/v1/register', params),
  requestCrmOtp: (params: IRequestCrmOtpParams) =>
    request.post<IRequestCrmOtpResponse>('/api/auth/v1/otp/verification', params),
  // Forgot password for CRM and Live
  forgotPasswordLive: (params: IForgotPasswordLiveParams) =>
    request.post<IForgotPasswordLiveResponse>('/api/auth/v1/password/reset', params),
  extendToken: (params: IExperienceLoginParams) =>
    request.patch<ILoginResponse>('/api/auth/v1/experience/extend', params),
  loginWithExperienceToken: (params: IExperienceLoginParams) =>
    request.post<ILoginResponse>('/api/auth/v1/experience/login', params)
};
